module.exports = __webpack_public_path__ + "static/media/FicheTechnique2024_en.b967fbf1.png";